import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SmsService } from '@services/sms.service';
import { SmsTemplate } from '@models/sms/templates';
// eslint-disable-next-line max-len
import { SmsTemplateCreateEditModalComponent } from '@modules/sms/templates/create-edit-modal/sms-template-create-edit-modal.component';
import { AtlasToastService } from '@services/atlas-toast.service';

@Component({
  selector: 'wsb-sms-template-preview-modal',
  templateUrl: './sms-template-preview-modal.component.html',
  styleUrls: ['./sms-template-preview-modal.component.scss'],
  standalone: false
})
export class SmsTemplatePreviewModalComponent implements OnInit {
  @ViewChild('deleteTemplateConfirmModal') deleteTemplateConfirmModal;
  @Input() templateId: number;

  template?: SmsTemplate;

  public updated = new EventEmitter();

  private confirmModal?: NgbModalRef;

  constructor(
    public activeModal: NgbActiveModal,
    private smsService: SmsService,
    private modalService: NgbModal,
    private atlasToast: AtlasToastService
  ) {}

  ngOnInit(): void {
    this.updateTemplate();
  }

  private updateTemplate() {
    this.smsService.getSmsTemplate(this.templateId).subscribe(template => {
      this.template = template;
    });
  }

  deleteTemplate(): void {
    this.confirmModal = this.modalService.open(this.deleteTemplateConfirmModal);
  }

  deleteTemplateConfirm(): void {
    this.smsService.deleteSmsTemplate(this.templateId).subscribe(
      () => {
        this.confirmModal.close();
        this.activeModal.close();
        this.updated.emit();
        this.atlasToast.success('common_success', null);
      },
      () => {
        this.atlasToast.error('common_error', null);
      }
    );
  }

  openSmsTemplateEditModal() {
    const options: NgbModalOptions = {
      size: 'lg'
    };
    const createSmsTemplateModal = this.modalService.open(SmsTemplateCreateEditModalComponent, options);
    createSmsTemplateModal.componentInstance.smsTemplate = this.template;
    createSmsTemplateModal.result.then(
      () => {
        this.updateTemplate();
        this.updated.emit();
      },
      () => {}
    );
  }

  sendSmsTemplate() {
    window.location.href = `/sms/send?atlas_template_id=${this.template.idTemplate}`;
  }
}
